import { Link } from "react-router-dom";
import carousel1 from "./img/ss1n.png";
import carousel2 from "./img/ss2n.png";

function Carousel() {
  return (
    <div
      className="home-hero container-fluid p-0 mb-0 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div
        id="header-carousel"
        className="carousel slide"
        data-bs-ride="carousel"
      >
        <div className="carousel-inner">
          <div className="carousel-item active">
            <img className="w-100" src={carousel1} alt="Insurance hero slide 1" loading="eager" />
            <div className="carousel-caption px-3 px-md-4">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-7 col-xl-6">
                    <p className="text-primary fw-semibold text-uppercase small mb-2 mb-md-3">
                      Insure Karo, Secure Raho
                    </p>
                    <h1 className="home-hero-title text-dark mb-3 mb-md-4 animated slideInDown">
                      Insurance Creates Wealth For Everyone
                    </h1>
                    <p className="home-hero-lead text-body mb-4 mb-md-5 pe-lg-4">
                      Your trusted partner for all your insurance needs—expert
                      advice, wide coverage, and service you can rely on.
                    </p>
                    <Link
                      to="/about"
                      className="btn btn-primary py-3 px-4 px-md-5"
                    >
                      More Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="carousel-item">
            <img className="w-100" src={carousel2} alt="Insurance hero slide 2" loading="lazy" />
            <div className="carousel-caption px-3 px-md-4">
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-7 col-xl-6">
                    <p className="text-primary fw-semibold text-uppercase small mb-2 mb-md-3">
                      Ebix Insurance Broking
                    </p>
                    <h1 className="home-hero-title text-dark mb-3 mb-md-4 animated slideInDown">
                      The Best Insurance Begins Here
                    </h1>
                    <p className="home-hero-lead text-body mb-4 mb-md-5 pe-lg-4">
                      Your trusted partner for all your insurance needs—expert
                      advice, wide coverage, and service you can rely on.
                    </p>
                    <Link
                      to="/about"
                      className="btn btn-primary py-3 px-4 px-md-5"
                    >
                      More Details
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#header-carousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
}

export default Carousel;
